<template>
  <hb-basic-page
      :action-buttons="$vuetify.breakpoint.smAndDown ? {} : {}"
      :fill-height="loading || filteredMessages.length === 0"
      :loading="loading"
      :subtle-loading="subtleLoading"
      :title="$tc(`message_center.message`,2)"
      name="message-center-view"
  >
    <v-col v-if="!loading && filteredMessages.length > 0" cols="12" lg="10" md="10" offset-lg="1"
           offset-md="1" offset-xl="2"
           xl="8">

      <template v-for="message in filteredMessages">
        <v-card class="mb-5">
          <v-card-title>
            <div>
              <div class="mb-1">
                <span v-if="message.sticky"><v-icon>mdi mdi-pin</v-icon></span>
                {{ message.title }}
              </div>
              <v-chip x-small>
                {{ getCategoryText(message) }}
              </v-chip>
            </div>
            <v-spacer/>
            <div class="caption">
              <p>{{ $formatDateTime(message.createdAt) }}</p>
              <p class="text-right font-weight-bold"> {{ message.author }} </p>
            </div>
          </v-card-title>
          <v-divider/>
          <v-card-text>
            <div>
              <vue-markdown class="vue-markdown" :source="message.message"></vue-markdown>
            </div>
            <!--<v-btn block text>
              <v-icon>mdi mdi-menu-down</v-icon>
            </v-btn>-->
          </v-card-text>
        </v-card>
      </template>

    </v-col>

    <v-col v-if="!loading && filteredMessages.length === 0" class="pa-0 fill-height" cols="12" lg="10" md="10"
           offset-lg="1"
           offset-md="1" offset-xl="2"
           xl="8">
      <v-row align="center" class="fill-height" no-gutters>
        <no-content-view
            :function-button="false"
            :reload-button="true"
            :title="$t('message_center.no_messages')"
            function-button-icon="add"
            title-icon="mdi mdi-playlist-edit"/>
      </v-row>
    </v-col>

  </hb-basic-page>
</template>

<script>
import NoContentView from "@/components/NoContentView";
import debounce from "lodash.debounce";
import messagecenterApi from '@/api/messagecenter';
import LoadingIndicator from "@/components/LoadingIndicator.vue";
import VueMarkdown from "@adapttive/vue-markdown";
import orderBy from "lodash/orderBy";
import dayjs from "dayjs";

export default {
  name: "AdminMessageCenterView",
  components: {LoadingIndicator, NoContentView, VueMarkdown},
  data() {
    return {
      loading: true,
      subtleLoading: false,
      options: {},
      messages: [],
      titleButton: {
        text: this.$t('message_center.create_message'),
        icon: 'add',
        callback: this.handleCreateMessage,
        primary: true,
      },
      headers: [
        {
          text: this.$t('message_center.title_field'),
          value: 'title',
        },
        {
          text: this.$t('message_center.message'),
          value: 'message',
        },
        {
          text: this.$t('message_center.category'),
          value: 'category',
        },
        {
          text: this.$t('message_center.author'),
          value: 'author',
          width: '150px',
        },
        {
          text: this.$t('message_center.published'),
          value: 'published',
          width: '150px',
        },
        {
          text: this.$t('message_center.sticky'),
          value: 'sticky',
          width: '150px',
        },
        {
          text: this.$t('message_center.created_at'),
          value: 'createdAt',
//          width: '150px',
        },
        {
          value: 'actions',
          width: '60px',
          sortable: false,
        },
      ],
      searchString: '',
    }
  },
  methods: {
    getCategoryText(item) {
      return this.categories.find(c => c.value === item.category).text
    },
    handleCreateMessage() {
      this.$router.push({name: 'create_messagecenter_message'});
    },
    openEditMessageView(task) {
      this.$router.push({name: "edit_messagecenter_message", params: {id: task.id}});
    },
    async reloadMessages() {
      if (this.messages.length > 0) {
        this.subtleLoading = true;
        this.loading = false;
      } else {
        this.subtleLoading = false;
        this.loading = true;
      }
      try {
        let messages = await messagecenterApi.getMessages();
        this.messages = messages.map(m => {
          m._deleteLoading = false;
          return m;
        });
      } catch (e) {
        this.$handleApiError(e, this.$t('errors.error_loading_messages'));
      }
      this.loading = false;
      this.subtleLoading = false;
    },
    handleSearch(e) {
      this.searchString = e;
    },
    async deleteMessage(message) {
      const confirm = await this.$confirmDelete(this.$t('message_center.confirm_delete'), this.$t('message_center.confirm_delete_text'));
      if (!confirm) return;

      message._deleteLoading = true;
      try {
        await messagecenterApi.deleteMessage(message.id);
        this.$showSuccessNotification(this.$t('message_center.deleted_successfully'));
        message._deleteLoading = false;
        this.reloadMessages();
      } catch (error) {
        this.$handleApiError(error, this.$t('errors.error_deleting_message'));
      }
    },
  },
  computed: {
    categories() {
      return messagecenterApi.getCategories();
    },
    filteredMessages() {
      return orderBy(this.messages, ['sticky', 'createdAt'], ['desc', 'desc']);
    },
  },
  created() {
    this.debouncedSearch = debounce(this.handleSearch, 450, {maxWait: 5000});
  },
  async mounted() {
    localStorage.setItem('latestMessagesRead', dayjs().toISOString());
    await this.$store.commit('setLatestMessagesRead');
    await this.reloadMessages();
    this.loading = false;
  }
}
</script>

<style scoped lang="scss">

.fade-out {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 10; /* number of lines to show */
  -webkit-box-orient: vertical;
}

.fade-out:after {
  content: "";
  height: 50%;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #fff);
}

</style>
